import { AnyAction } from "redux";
import { IDictionary } from "../../Components/ExternalControl/ExternalControlContainer";
import * as actions from "../Actions/ControllingEntitySubjects";

export interface IControllingEntitySubjectsState {
  controllingEntitySubjects: IDictionary[];
  isLoading?: boolean;
  isError?: boolean;
  error?: object;
}

export const controllingEntitySubjectsReducer = (
  state: IControllingEntitySubjectsState = {
      controllingEntitySubjects: []
  },
  action: AnyAction
) => {
  switch (action.type) {
    case actions.GET_CONTROLING_ENTITY_SUBJECTS_REQUESTED:
      return { ...state, isLoading: true };
    case actions.GET_CONTROLING_ENTITY_SUBJECTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        controllingEntitySubjects: action.payload,
      };
    case actions.GET_CONTROLING_ENTITY_SUBJECTS_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };

    case actions.SET_CONTROLLING_ENTITY_ACTIVE_REQUEST:
      return { ...state, isLoading: true };
    case actions.SET_CONTROLLING_ENTITY_ACTIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        controllingEntitySubjects: state.controllingEntitySubjects?.map(
          (el) => {
            if (el.entryId === action.payload.entryId) {
              el.active = true;
            }
            return el;
          }
        ),
      };
    case actions.SET_CONTROLLING_ENTITY_ACTIVE_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };

    case actions.SET_CONTROLLING_ENTITY_DEACTIVATED_REQUEST:
      return { ...state, isLoading: true };
    case actions.SET_CONTROLLING_ENTITY_DEACTIVATED_SUCCESS:
      return {
        ...state,
        isLoading: false,
        controllingEntitySubjects: state.controllingEntitySubjects?.map(
          (el) => {
            if (el.entryId === action.payload.entryId) {
              el.active = false;
            }
            return el;
          }
        ),
      };
    case actions.SET_CONTROLLING_ENTITY_DEACTIVATED_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };

    case actions.CREATE_CONTROLLING_ENTITY_REQUEST:
      return { ...state, isLoading: true };
    case actions.CREATE_CONTROLLING_ENTITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        controllingEntitySubjects: [...state.controllingEntitySubjects, action.payload],
      };
    case actions.GET_CONTROLING_ENTITY_SUBJECTS_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };

    default:
      return state;
  }
};
